import { render, staticRenderFns } from "./repair-new.vue?vue&type=template&id=cf1d5cb8&"
import script from "./repair-new.vue?vue&type=script&lang=js&"
export * from "./repair-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports